import React, { forwardRef } from 'react';

import MediaQuery from './media-query';

/**
 * @type {React.FC<PropsWithChildren<{
 *  mediaQuery?: string;
 *  direction?: string;
 *  children?: Element;
 * }>>}
 */
const MobileOnly = forwardRef(({ children, mediaQuery = 'sm', ...otherProps }, ref) => (
  <MediaQuery ref={ref} mediaQuery={mediaQuery} {...otherProps} direction='down'>
    {children}
  </MediaQuery>
));
MobileOnly.snapshot = false;

export default MobileOnly;
